// @flow
import React from 'react';
import { ShowLoaderIfAnyQueryIsPending } from '@presentational/ShowLoaderIfAnyQueryIsPending';
import { UserContextProvider } from '@src/contexts/UserContextProvider';
import { SPOrgContextProvider } from '@streaming-projects/orgs/contexts/SPOrgContextProvider';
import { SPUserCommitDetailsContextProvider } from '@streaming-projects/user-commit-details/contexts/SPUserCommitDetailsContextProvider';
import { SPUserCommitDetailsTopLevelContainerForm } from '@streaming-projects/user-commit-details/SPUserCommitDetailsTopLevelContainerForm';
import { SPRateCardMetaContextProvider } from '@streaming-projects/orgs/contexts/SPRateCardMetaContextProvider';
import { SPUserCommitPricingStatusContextProvider } from '@streaming-projects/user-commit-details/contexts/SPUserCommitPricingStatusContextProvider';

import SPUserCommitDetailsBreadcrumbs from './breadcrumbs/SPUserCommitDetailsBreadcrumbs';
import { SPUserCommitMetadataContextProvider } from './contexts/SPUserCommitMetadataContextProvider';

export const SPUserCommitDetailsTopLevelContainer = () => {
  /*

  Note: User Commit Page follow these simple steps:

  1. Fetch the latest pricing status
  2. Fetch User Commit Details ( including Discounts )
  3. Display Discounts  based on the Pricing Status
      ( e.g., if it is failed, then show a failure, if it is success, then use the discounts fetched in step 2 and show MLD section
  4. Display Summary tabs based on the Pricing Status - similar to the above but reftech the data using an API because it won't come from User Commit Details
  5. All other sections will be displayed based on data in the second step
  6. Now, after the page has been loaded like this, any interaction on the page will always reload the page
      ( e.g., when the user makes any edit in any section, the entire page gets reloaded, even switching to new tabs in commit summary reloads the entire page
  7. This is to ensure that all the data is accurate and valid - ie, based on the latest pricing status
  8.  If we don't do it this way, then think about what happens in this scenario:
          a. Load the page. Let's say Pricing Status = success
          b. We show MLD based on the data received in commit details
          c. Now when user switches to a new tab, say, SFDC tab, earlier, we were fetching the latest pricing status and then fetching sfdc data
          d. Now, because of auto-calc, it might so happen that the user might see that the pricing status is successful and the sfdc views data is refreshed but MLD data is stale
          e. Refreshing the page always keeps things very simple - while not compromising UX a lot

   */
  return (
    <>
      <ShowLoaderIfAnyQueryIsPending />
      <UserContextProvider>
        <SPOrgContextProvider>
          <SPUserCommitPricingStatusContextProvider>
            <SPUserCommitDetailsContextProvider>
              <SPUserCommitMetadataContextProvider>
                <SPRateCardMetaContextProvider>
                  <SPUserCommitDetailsBreadcrumbs />
                  <SPUserCommitDetailsTopLevelContainerForm />
                </SPRateCardMetaContextProvider>
              </SPUserCommitMetadataContextProvider>
            </SPUserCommitDetailsContextProvider>
          </SPUserCommitPricingStatusContextProvider>
        </SPOrgContextProvider>
      </UserContextProvider>
    </>
  );
};
